"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useScrollRelative;

var _react = require("react");

var _useWebChatUIContext2 = _interopRequireDefault(require("./useWebChatUIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useScrollRelative() {
  var _useWebChatUIContext = (0, _useWebChatUIContext2.default)(),
      scrollRelativeCallbacksRef = _useWebChatUIContext.scrollRelativeCallbacksRef;

  return (0, _react.useCallback)(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return scrollRelativeCallbacksRef.current.forEach(function (callback) {
      return callback.apply(void 0, args);
    });
  }, [scrollRelativeCallbacksRef]);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VTY3JvbGxSZWxhdGl2ZSIsInVzZVdlYkNoYXRVSUNvbnRleHQiLCJzY3JvbGxSZWxhdGl2ZUNhbGxiYWNrc1JlZiIsInVzZUNhbGxiYWNrIiwiYXJncyIsImN1cnJlbnQiLCJmb3JFYWNoIiwiY2FsbGJhY2siXSwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9ob29rcy9pbnRlcm5hbC91c2VTY3JvbGxSZWxhdGl2ZS5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyB1c2VDYWxsYmFjayB9IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IHVzZVdlYkNoYXRVSUNvbnRleHQgZnJvbSAnLi91c2VXZWJDaGF0VUlDb250ZXh0JztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdXNlU2Nyb2xsUmVsYXRpdmUoKSB7XG4gIGNvbnN0IHsgc2Nyb2xsUmVsYXRpdmVDYWxsYmFja3NSZWYgfSA9IHVzZVdlYkNoYXRVSUNvbnRleHQoKTtcblxuICByZXR1cm4gdXNlQ2FsbGJhY2soXG4gICAgKC4uLmFyZ3MpID0+IHNjcm9sbFJlbGF0aXZlQ2FsbGJhY2tzUmVmLmN1cnJlbnQuZm9yRWFjaChjYWxsYmFjayA9PiBjYWxsYmFjayguLi5hcmdzKSksXG4gICAgW3Njcm9sbFJlbGF0aXZlQ2FsbGJhY2tzUmVmXVxuICApO1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBRUE7Ozs7QUFFZSxTQUFTQSxpQkFBVCxHQUE2QjtFQUMxQywyQkFBdUMsSUFBQUMsNkJBQUEsR0FBdkM7RUFBQSxJQUFRQywwQkFBUix3QkFBUUEsMEJBQVI7O0VBRUEsT0FBTyxJQUFBQyxrQkFBQSxFQUNMO0lBQUEsa0NBQUlDLElBQUo7TUFBSUEsSUFBSjtJQUFBOztJQUFBLE9BQWFGLDBCQUEwQixDQUFDRyxPQUEzQixDQUFtQ0MsT0FBbkMsQ0FBMkMsVUFBQUMsUUFBUTtNQUFBLE9BQUlBLFFBQVEsTUFBUixTQUFZSCxJQUFaLENBQUo7SUFBQSxDQUFuRCxDQUFiO0VBQUEsQ0FESyxFQUVMLENBQUNGLDBCQUFELENBRkssQ0FBUDtBQUlEIn0=